import React from 'react';
import styled from '@emotion/styled';

const InlineContainer = styled.div`
  display: flex;
  ${({ width }) =>
    width ? 'width: ' + width + ';' : ''} align-items: baseline;
  flex-direction: row;
  ${({ wrap }) =>
    !!wrap === true
      ? 'flex-wrap: wrap;'
      : ''} & > span,
    & > a,
    & > button,
    & > div {
    ${({ spacing }) => {
      return typeof spacing !== 'undefined'
        ? `
        margin-right: ${spacing};

        &:last-child {
          margin-right: 0;
        }
      `
        : ``;
    }};
  }
`;

const InlineButtonContainer = props => {
  return <InlineContainer {...props} />;
};

export default InlineButtonContainer;
